// extracted by mini-css-extract-plugin
module.exports = {"footer":"_93444fe79c--footer--1WsoG","footer-withNbConsultant":"_93444fe79c--footer-withNbConsultant--5KPR-","footer--submit":"_93444fe79c--footer--submit--12q0V"};